import type { OnChangeFn, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { useQualityRequestColumns } from "../hooks/useQualityRequestColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { QualityApproval } from "@/graphql/codegen/graphql"

interface QualityRequestTableProps {
  data: QualityApproval[]
  loading?: boolean
  error?: CombinedError | Error
  sorting: SortingState
  containerRef?: RefObject<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onScroll?: () => void
  onProductView: (qualityApproval: QualityApproval) => void
  onApprovalRequest: (qualityApproval: QualityApproval) => void
  onApprovalCancel: (qualityApproval: QualityApproval) => void
}

export const QualityRequestTable: FC<QualityRequestTableProps> = ({
  data,
  error,
  loading = false,
  sorting,
  containerRef,
  onSortingChange,
  onScroll,
  onProductView,
  onApprovalRequest,
  onApprovalCancel,
}) => {
  const columns = useQualityRequestColumns({ onProductView, onApprovalRequest, onApprovalCancel })

  return (
    <AerosBaseTable
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: loading,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        container: { ref: containerRef, onScroll },
      }}
      noDataMessage='No requests found'
    />
  )
}
